import React from 'react';

type Props = {
  id: string;
  value?: string | number;
};

const HiddenInput = (props: Props) => {
  const { id, ...rest } = props;
  return <input id={id} name={id} data-testid={`input-${id}`} type="hidden" {...rest} />;
};

export default HiddenInput;
